export default {
  type: Object,
  default () {
    return { transform: 'scaleX(-1)' }
  }
}
